import { render, staticRenderFns } from "./relationAnaly.vue?vue&type=template&id=f60fbf4e"
import script from "./relationAnaly.vue?vue&type=script&lang=js"
export * from "./relationAnaly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports